import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

import useMutationHook from '@/hooks/useMutationHook';
import useModal from '@/hooks/useModal';
import useToast from '@/hooks/useToast';
import TitleNAdditionalContents from '@/components/ContextPrinter/TitleNAdditionalContents';
import TitleNContentForm from '@/components/InputForm/TitleNContentForm';
import BottomFixedButton from '@/components/Button/BottomFixedButton';
import { API, URLs } from '@/api';
import { FontStyle } from '@/utils/StyleUtil';

interface IAccuse {
    contentType: number;
    contentId: number;
    refetch?: Function;
}

const title = '신고사유를 선택해 주세요';
const subTitle =
    '신고 후 철회는 불가능하며, 허위 신고일 경우 서비스 이용에\n제재가 발생할 수 있으니 신중히 신고해주세요';

const AccuseList = [
    '동일한 질문/답변을 반복',
    '스팸/홍보',
    '음란/청소년 유해',
    '욕설/비방 표현',
    '개인 정보 노출',
    '기타',
];

const placeHolder = '신고 사유를 남겨주세요';

const InAAccuse = ({ contentType, contentId, refetch }: IAccuse) => {
    const { addModal, removeCurrentModal } = useModal();
    const { openToast } = useToast();
    const [selected, setSelected] = useState(-1);
    const [accuseReason, setAccuseReason] = useState('');
    const [isActive, setIsActive] = useState(false);

    const { mutate, errorPopUp } = useMutationHook(
        ['ina-accuse'],
        async () => {
            return await API.post(URLs.report.report, {
                contentType: contentType,
                contentId: contentId,
                reportComment: accuseReason,
            });
        },
        {
            onSuccess: () => {
                addModal({
                    key: 'popUp',
                    props: {
                        type: 'confirm',
                        content: '신고 접수가 완료되었습니다.\n관리자 검토 후 조치 예정입니다.',
                        contentStyle: FontStyle(14, 22, '400', '#444444', -1),
                        onClickConfirm: () => {
                            removeCurrentModal(); // popup remove
                            removeCurrentModal(); // accuse remove
                            if (refetch) refetch();
                        },
                    },
                });
            },
            onError: err => {
                errorPopUp(err?.response?.status);
            },
        },
    );

    const onClickAccuse = () => {
        if (isActive) mutate({});
        else {
            if (selected !== 5 && !accuseReason.length) openToast('신고사유를 선택해 주세요');
        }
    };

    useEffect(() => {
        if (selected === -1) setIsActive(false);
        else if (selected === 5) {
            if (accuseReason.length >= 1) setIsActive(true);
            else setIsActive(false);
        } else setIsActive(true);
    }, [selected, accuseReason]);

    return (
        <>
            <Container id="test3">
                <TitleNAdditionalContents title={title} subText={subTitle} />
                <div style={{ height: '14px' }} />
                {AccuseList.map((item, index) => (
                    <ListContainer
                        key={`${item}_${index}`}
                        onClick={() => {
                            setSelected(index);
                            if (index !== 5) setAccuseReason(AccuseList[index]);
                            else setAccuseReason('');
                        }}
                        isSelected={index === selected}
                    >
                        <div className="round">{index === selected && <div className="inner_round" />}</div>
                        <div className="accuse_reason">{item}</div>
                    </ListContainer>
                ))}
                {selected === 5 && (
                    <>
                        <div style={{ height: '18px' }} />
                        <TitleNContentForm
                            content={accuseReason}
                            contentPlaceHolder={placeHolder}
                            contentMaxLength={400}
                            onContentChange={(text: string) => setAccuseReason(text)}
                            isMoving={true}
                        />
                    </>
                )}
            </Container>
            <BottomFixedButton
                buttonColor={isActive ? '#0ec4cf' : '#acacac'}
                text="신고하기"
                onClickButton={onClickAccuse}
            />
        </>
    );
};

const Container = styled.div`
    width: 100%;
    padding: 0 20px 80px 20px;
`;

const ListContainer = styled.div<{ isSelected: boolean }>`
    display: flex;
    align-items: center;
    width: fit-content;
    margin-top: 26px;

    .round {
        ${({ theme }) => theme.flex.flexOnly}
        ${({ theme }) => theme.flex.justifyCenter}
        width: 22px;
        height: 22px;
        background-color: ${({ isSelected }) => (isSelected ? '#0ec4cf' : '#dadada')};
        border-radius: 22px;
        margin-right: 5px;
    }
    .inner_round {
        width: 10px;
        height: 10px;
        background-color: #ffffff;
        border-radius: 10px;
    }
    .accuse_reason {
        ${FontStyle(14, 22, '400', '#686868', -1)};
    }
`;

export default InAAccuse;
